import { Controller } from "stimulus";

export default class extends Controller
{
    connect()
    {

    }

    handleResponse(event)
    {
        if (event.detail[0].success)
        {
            const editEvent = new CustomEvent("show-toast", { detail: "Panel Info successfully updated!" });
            window.dispatchEvent(editEvent);
        }
        else
        {
            const errorEvent = new CustomEvent("show-toast", { detail: "An error occurred: " + event.detail[0].error })
            window.dispatchEvent(errorEvent);
        }
    }
}